import moment from "moment";
import PropTypes from "prop-types";
import React from "react";

const CustomDownloadEcardLayout = ({ data, providerId }) => {
  switch (providerId) {
    case "RMG":
    case "RmgSG":
      return (
        <CardItemLayout
          value={data}
          frontImage="rafflesMedicalGroupFront.png"
          backImage="rafflesMedicalGroupBack.png"
          type="RMG"
        />
      );
    case "ParkWaySG":
    case "ParkwayShenton":
      return (
        <CardItemLayout
          value={data}
          frontImage="parkwayFront.png"
          backImage="parkwayBack.png"
          type="ParkWay"
        />
      );
    case "AVIVA":
      return (
        <CardItemLayout
          value={data}
          frontImage="avivaFront.jpg"
          backImage="avivaBack.jpg"
          type="AVIVA"
        />
      );
    case "IHP":
    case "ihp":
      return (
        <CardItemLayout value={data} frontImage="IHPFront.png" backImage="IHPBack.png" type="IHP" />
      );
    case "Non-Nex":
      return (
        <CardItemLayout
          value={data}
          frontImage="supremeFront.jpg"
          backImage="supremeBack.jpg"
          type="Supreme"
        />
      );
    case "Nex":
      return (
        <CardItemLayout
          value={data}
          frontImage="liveGreatFront.jpg"
          backImage="liveGreatBack.jpg"
          type="LiveGreat"
        />
      );
    default:
      return null;
  }
};

// START AVIVA CARD
const AvivaCard = ({ value }) => {
  return (
    <div id={`ecard-${value.cardId}`} style={{ display: "none" }}>
      <div
        className="ecards-image aviva"
        style={{
          backgroundImage: "url('../../../assets/images/ecards/avivaFront.jpg')",
        }}
      >
        <div className="aviva">
          <div className="policy-info download-ecards" style={{marginBottom: "30px"}}>
            <div>Policy No.: {value.policyNumber}</div>
            <div>{value.timeStamp}</div>
          </div>

          <div className="company-section download-ecards">
            <div>Company</div>
            <div>
              <strong>{value.clientCode}</strong>
            </div>
          </div>
          <div className="grid-container download-ecards">
            <div className="grid-item">
              <div>IC/BC/FIN No</div>
              <div>
                <strong>{value.memberIdentification}</strong>
              </div>
            </div>
            <div className="grid-item">
              <div>Cardholder</div>
              <div>
                <strong>{value.memberName}</strong>
              </div>
            </div>
            <div className="grid-item">
              <div>Rel</div>
              <div>
                <strong>{value.memberRelationship}</strong>
              </div>
            </div>
            <div className="grid-item">
              <div>Effective Date</div>
              <div>
                <strong>{moment(value.policyEffectiveDate).format("D MMM YYYY")}</strong>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="ecards-image"
        style={{
          backgroundImage: "url('../../../assets/images/ecards/avivaBack.jpg')",
        }}
      >
        <div className="info-grid download-ecards" style={{ marginTop: 0 }}>
          <p
            style={{ marginTop: 5 }}
            dangerouslySetInnerHTML={{
              __html: value.terms,
            }}
          />
        </div>
      </div>
    </div>
  );
};

AvivaCard.propTypes = {
  value: PropTypes.object.isRequired,
};
// END AVIVA CARD

// START SUPREME / NONNEX CARD
const SupremeCard = ({ value, frontImage, backImage }) => {
  return (
    <div id={`ecard-${value.cardId}`} style={{ display: "none" }}>
      <div
        className="ecards-image"
        style={{
          backgroundImage: `url('../../../assets/images/ecards/${frontImage}')`,
          aspectRatio: "15 / 9",
          border:"1px solid #cecece",
        }}
      >
        <div className="nex">
          <div className="time-stamp download-ecards">{value.timeStamp}</div>
          <div className="nex-container download-ecards">
            <div className="row">
              <div className="col-6">Policyholder</div>
              <div className="col-6">: {value.clientCode}</div>
            </div>
            <div className="row">
              <div className="col-6">Member name</div>
              <div className="col-6">: {value.employeeName}</div>
            </div>
            <div className="row">
              <div className="col-6">Policy number</div>
              <div className="col-6">: {value.policyNumber}</div>
            </div>
            <div className="row">
              <div className="col-6">NRIC/FIN/PP No</div>
              <div className="col-6">: {value.memberIdentification}</div>
            </div>
            <div className="row">
              <div className="col-6">GP</div>
              <div className="col-6">
                <div className="row" style={{ marginBottom: "0px" }}>
                  <div className="col-6">: {value.panelCoverGpAe}</div>
                  <div className="col-6">
                    <div className="row" style={{ marginBottom: "0px" }}>
                      <div className="col-6">Copay</div>
                      <div className="col-6">: {value.panelCoverCopayGpAe}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-6">Rest.SOC</div>
              <div className="col-6">
                <div className="row" style={{ marginBottom: "0px" }}>
                  <div className="col-6">: {value.panelCoverRestructured}</div>
                  <div className="col-6">
                    <div className="row" style={{ marginBottom: "0px" }}>
                      <div className="col-6">Copay</div>
                      <div className="col-6">: {value.panelCoverCopayRestructured}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-6">SP-Pte</div>
              <div className="col-6">
                <div className="row" style={{ marginBottom: "0px" }}>
                  <div className="col-6">: {value.panelCoverPte}</div>
                  <div className="col-6">
                    <div className="row" style={{ marginBottom: "0px" }}>
                      <div className="col-6">Copay</div>
                      <div className="col-6">: {value.panelCoverCopayPte}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="ecards-image"
        style={{
          backgroundImage: `url('../../../assets/images/ecards/${backImage}')`,
          aspectRatio: "15 / 9",
          border:"1px solid #cecece"
        }}
      >
        <div className="info-grid download-ecards" style={{ marginTop: 0, color: "#a20f0f" }}>
          <p
            style={{ marginTop: 5 }}
            dangerouslySetInnerHTML={{
              __html: value.terms,
            }}
          />
        </div>
      </div>
    </div>
  );
};

SupremeCard.propTypes = {
  value: PropTypes.object.isRequired,
  frontImage: PropTypes.string.isRequired,
  backImage: PropTypes.string.isRequired,
};
// END SUPREME / NONNEX AVIVA CARD

// START LIVEGREAT / NEX AVIVA CARD
const LiveGreatCard = ({ value, frontImage, backImage }) => {
  return (
    <div id={`ecard-${value.cardId}`} style={{ display: "none" }}>
      <div
        className="ecards-image"
        style={{
          backgroundImage: `url('../../../assets/images/ecards/${frontImage}')`,
          aspectRatio: "15 / 9",
          border:"1px solid #cecece"
        }}
      >
        <div className="non-nex download-ecards">
          <div className="time-stamp download-ecards">
            <div>
              <p>Terms and Conditions</p>
              <p
                dangerouslySetInnerHTML={{
                  __html: value.terms,
                }}
              />
            </div>
            <div>
              <p>
                <strong>{value.timeStamp}</strong>
              </p>
            </div>
          </div>
          <div className="non-nex-container download-ecards">
            <div className="row">
              <div className="col-7">
                <strong>{value.clientCode}</strong>
              </div>
            </div>
            <div className="row">
              <div className="col-7">Policy No.</div>
              <div className="col-5">: {value.policyNumber}</div>
            </div>
            <div className="row">
              <div className="col-7">Member name</div>
              <div className="col-5">: {value.memberName}</div>
            </div>
            <div className="row">
              <div className="col-7">NRIC/FIN/PP No</div>
              <div className="col-5">: {value.memberIdentification}</div>
            </div>
            <div className="row">
              <div className="col-7">Relationship</div>
              <div className="col-5">: {value.memberRelationshipValue}</div>
            </div>
            <div className="row">
              <div className="col-7">Effective Date</div>
              <div className="col-5">
                : {moment(value.policyEffectiveDate).format("DD MMM YYYY")}
              </div>
            </div>
            <div className="row">
              <div className="col-12">
                <hr style={{ margin: 0 }} />
              </div>
            </div>
            <div className="row">
              <div className="col-7">Panel GP / Panel A&E Ctr Cover</div>
              <div className="col-5">
                <div className="row" style={{ marginBottom: "0px" }}>
                  <div className="col-6">: {value.panelCoverGpAe}</div>
                  <div className="col-6">
                    <div className="row" style={{ marginBottom: "0px" }}>
                      <div className="col-6">Copay</div>
                      <div className="col-6">: {value.panelCoverCopayGpAe}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-7">Panel Restr Hosp Specialist (SOC) Cover</div>
              <div className="col-5">
                <div className="row" style={{ marginBottom: "0px" }}>
                  <div className="col-6">: {value.panelCoverRestructured}</div>
                  <div className="col-6">
                    <div className="row" style={{ marginBottom: "0px" }}>
                      <div className="col-6">Copay</div>
                      <div className="col-6">: {value.panelCoverCopayRestructured}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-7">Panel Pte Specialist Cover</div>
              <div className="col-5">
                <div className="row" style={{ marginBottom: "0px" }}>
                  <div className="col-6">: {value.panelCoverPte}</div>
                  <div className="col-6">
                    <div className="row" style={{ marginBottom: "0px" }}>
                      <div className="col-6">Copay</div>
                      <div className="col-6">: {value.panelCoverCopayPte}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="ecards-image"
        style={{
          backgroundImage: `url('../../../assets/images/ecards/${backImage}')`,
          aspectRatio: "15 / 9",
        }}
      ></div>
    </div>
  );
};

LiveGreatCard.propTypes = {
  value: PropTypes.object.isRequired,
  frontImage: PropTypes.string.isRequired,
  backImage: PropTypes.string.isRequired,
};
// END LIVEGREAT / NEX AVIVA CARD

// START DEFAULT CUSTOM CARD
const DefaultTemplateEcard = ({ value, frontImage, backImage, type }) => {
  return (
    <div id={`ecard-${value.cardId}`} style={{ display: "none" }}>
      <div
        className="ecards-image"
        style={{
          backgroundImage: `url('../../../assets/images/ecards/${frontImage}')`,
        }}
      >
        <br />
        <div className="info-grid download-ecards" style={type === "IHP" ? { color: "#ffffff" } : {marginTop: "50px"}}>
          <div>
            <span>{value.memberName}</span>
          </div>
          <div></div>

          <div>
            <span>{value.memberIdentification}</span>
            <span>{value.memberGender === "Male" ? "M" : "F"}</span>
          </div>
          <div>
            <span>{value.memberBirthDateValue}</span>
          </div>

          <div>
            <span>{value.memberEntity}</span>
          </div>
          <div>
            <span>{value.clientCode}</span>
          </div>

          <div>
            <span>Dependent Of</span>
          </div>
          <div>
            <span>NRIC/PP No.</span>
          </div>

          <div>
            <span>
              {value.employeeIdentification == value.memberIdentification
                ? "N.A."
                : value.employeeName}
            </span>
          </div>
          <div>
            <span>
              {value.employeeIdentification == value.memberIdentification
                ? ""
                : value.employeeIdentification}
            </span>
          </div>
        </div>
      </div>
      <div
        className="ecards-image"
        style={{
          backgroundImage: `url('../../../assets/images/ecards/${backImage}')`,
        }}
      >
        <div className="info-terms download-ecards" style={{ marginTop: 0 }}>
          <p
            style={{ marginTop: 5 }}
            dangerouslySetInnerHTML={{
              __html: value.terms,
            }}
          />
        </div>
      </div>
    </div>
  );
};

DefaultTemplateEcard.propTypes = {
  value: PropTypes.object.isRequired,
  frontImage: PropTypes.string.isRequired,
  backImage: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
};
// END DEFAULT CUSTOM CARD

const CardItemLayout = ({ value, frontImage, backImage, type }) => {
  switch (type) {
    case "AVIVA":
      return <AvivaCard value={value} />;
    case "Supreme":
      return <SupremeCard value={value} frontImage={frontImage} backImage={backImage} />;
    case "LiveGreat":
      return <LiveGreatCard value={value} frontImage={frontImage} backImage={backImage} />;
    default:
      return (
        <DefaultTemplateEcard
          value={value}
          frontImage={frontImage}
          backImage={backImage}
          type={type}
        />
      );
  }
};

CardItemLayout.propTypes = {
  value: PropTypes.object.isRequired,
  frontImage: PropTypes.string.isRequired,
  backImage: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
};

CustomDownloadEcardLayout.propTypes = {
  data: PropTypes.object.isRequired,
  providerId: PropTypes.string.isRequired,
};

export default CustomDownloadEcardLayout;



// WEBPACK FOOTER //
// ./components/claim/CustomDownloadEcardLayout.js